import { uniq } from 'es-toolkit';

import { Insertion } from '@paragon/contract-library';
import { ReadonlyRecord } from '@paragon/utilities';

import { LayoutModelsLibraryState } from '../store';
import { getInsertionsWithPendingChangesGroupedByObjectGuid } from './changeTracker';

export function getParentGuids(state: LayoutModelsLibraryState, objectGuid: string) {
  const insertionsGroupedByObjectGuid = getInsertionsWithPendingChangesGroupedByObjectGuid(state);
  return getParentGuidsFromInsertions(insertionsGroupedByObjectGuid, objectGuid);
}

export function getParentGuidsFromInsertions(
  insertionsGroupedByObjectGuid: ReadonlyRecord<string, readonly Insertion[] | undefined>,
  objectGuid: string,
) {
  return uniq(insertionsGroupedByObjectGuid[objectGuid]?.map((insertion) => insertion.parentGuid) ?? []);
}
